import React from "react";
import { connect } from "react-redux";

import { getBasketItemsIssuesByStudentAndReason } from "state/school_money/selectors";
import { resolveBasketItemsIssues } from "state/school_money/actions";

import ModalDialog from "components/ModalDialog";
import ScrollableContainer from "components/ScrollableContainer";
import Button from "components/Button";
import StudentName from "components/school_money/StudentName";
import BasketItemIssue from "components/school_money/basket/BasketItemIssue";

import "./BasketItemsIssuesModal.css";

class BasketItemsIssuesModal extends React.Component {
  
  getReasonHeading(reason) {
    switch (reason) {
      case "expired": return "Expired";
      case "limited_places": return "Places Unavailable";
      case "out_of_stock": return "Out of Stock";
      case "insufficient_stock": return "Insufficient Stock";
      case "bookings_changed": return "Bookings Updated by School";
      default: return "Other";
    }
  }
  
  render() {
    return (
      <ModalDialog>
        <div className="basket-items-issues">
          <div className="basket-items-issues__heading">Important Message!</div>
          <p className="basket-items-issues__description">
            The following items in your basket are no longer available.
            <br />
            Below are the items affected.
          </p>
          <hr className="basket-items-issues__student-hr" />
          <ScrollableContainer className="basket-items-issues__body">
            {
              this.props.issuesByStudentAndReason.map((issuesByReason, studentID) => (
                <div className="basket-items-issues__student" key={studentID}>
                  <div className="basket-items-issues__student-name">
                    <StudentName studentID={studentID} />
                  </div>
                  {
                    issuesByReason.map((issues, reason) => (
                      <div className="basket-items-issues__reason" key={reason}>
                        <div className="basket-items-issues__reason-heading">
                          { this.getReasonHeading(reason) }
                        </div>
                        <div className="basket-items-issues__items">
                          {
                            issues.map(issue => (
                              <BasketItemIssue
                                key={`${issue.get("itemType")}:${issue.get("basketItemID")}`}
                                {...issue.toObject()}
                              />
                            ))
                          }
                        </div>
                      </div>
                    )).toList()
                  }
                </div>
              )).toList().interpose(
                <hr className="basket-items-issues__student-hr" />
              )
            }
          </ScrollableContainer>
          <hr className="basket-items-issues__student-hr" />
          <div className="basket-items-issues__button-container">
            <Button className="basket-items-issues__resolve-button" onClick={this.props.resolveBasketItemsIssues}>Update</Button>
          </div>
        </div>
      </ModalDialog>
    )
  }
  
}

export default connect(
  state => ({
    issuesByStudentAndReason: getBasketItemsIssuesByStudentAndReason(state)
  }),
  { resolveBasketItemsIssues }
)(BasketItemsIssuesModal);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/BasketItemsIssuesModal.js